import React, {useEffect, useState} from "react";
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

export default function PropertyImageGallery({property}) {
    const [images, setImages] = useState([]);
    
    const createImageCollection = () => {
        try{
            let gi = property.imageDefs.map((imageDef, index) => ({
                original: `data:image/jpeg;base64,${imageDef.fullSizeImageBase64Def}`,
                thumbnail: `data:image/jpeg;base64,${imageDef.thumbnailImageBase64Def}`
            }));
            
            setImages(prevItems => [...prevItems, ...gi]);            
        } catch (error) {
            console.log(error);
        }
    }
    
    useEffect(() => {
        createImageCollection();
    },[])
    
    useEffect(() => { console.log(images); }, [images]);
    
    return (
        images.length > 0 ? <ImageGallery items={images} originalHeight="660" thumbnailHeight="123" thumbnailWidth="153" showPlayButton={false} /> : null
    )
}

